if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('.product-form__submit--primary');
        this.stickySubmitButton = this.querySelector('.product-form__submit--sticky');
        this.scrollToSectionCTA = this.querySelector('[data-scroll-to-section]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.initStickySubmit();

        if (this.scrollToSectionCTA) {
          this.setupScrollToSection();
        }

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      initStickySubmit() {
        if (!this.stickySubmitButton) return;

        const footer = document.querySelector('footer.footer');
        let isPrimaryBtnAboveViewport = false;
        let isFooterVisible = false;
        const boundUpdateStickyCtaVisibility = updateStickyCtaVisibility.bind(this);

        // Show sticky CTA when primary button is above viewport
        const btnObserver = new IntersectionObserver(
          ([entry]) => {
            isPrimaryBtnAboveViewport = entry.boundingClientRect.bottom < 0;
            boundUpdateStickyCtaVisibility();
          },
          {
            root: null,
            threshold: 0,
          }
        );

        // Hide sticky CTA when footer is in viewport
        const footerObserver = new IntersectionObserver(
          ([entry]) => {
            isFooterVisible = entry.isIntersecting;
            boundUpdateStickyCtaVisibility();
          },
          {
            root: null,
            rootMargin: '0px 0px -100px 0px',
            threshold: 0,
          }
        );

        btnObserver.observe(this.submitButton);
        footerObserver.observe(footer);

        function updateStickyCtaVisibility() {
          this.stickySubmitButton.classList.toggle('visible', isPrimaryBtnAboveViewport && !isFooterVisible);
        }
      }

      setupScrollToSection() {
        const sectionToScrollToUrl = this.scrollToSectionCTA.dataset.scrollToSection;

        if (!sectionToScrollToUrl.includes('#')) { return; }

        const sectionToScrollTo = document.querySelector(sectionToScrollToUrl);
        const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');

        if (sectionToScrollTo) {
          this.scrollToSectionCTA.addEventListener('click', (e) => {
            e.preventDefault();

            const elementOffsetTop = sectionToScrollTo.offsetTop;
            const totalHeaderOffset = Array.from(headerGroupSections).reduce((total, el) => {
              return total + el.offsetHeight;
            }, 0);
            const scrollTop = elementOffsetTop - totalHeaderOffset;
      
            window.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
            });
          });
        } else {
          this.scrollToSectionCTA.remove();
        }
      }
    }
  );
}

function onVariantChange({ target: optionValueElement }) {
  if (!optionValueElement.dataset.variantId) {
    return false;
  }

  const productElement = this.querySelector('.product');
  const sectionId = this.dataset.sectionId;
  const oldProductUrl = productElement.dataset.productUrl;
  const newProductUrl = optionValueElement.dataset.productUrl;
  const newProductTitle = optionValueElement.dataset.productTitle;
  const newVariantId = optionValueElement.dataset.variantId;
  const stickyAtcButton = document.querySelector('.product-form__submit--sticky');

  let params = `section_id=${sectionId}&`;
  if (newVariantId) {
    // If the option value has a variant selection, call the section rendering api for that variant
    params += `variant=${newVariantId}`;
  } else {
    // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
    const selectedOptionValues = Array.from(this.querySelectorAll('.fieldset input:checked'))
      .map((element) => element.dataset.optionValueId)
      .join(',');
    params += `option_values=${selectedOptionValues}`;
  }

  // Call the section rendering api
  fetch(`${newProductUrl}?${params}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      if (newProductUrl && oldProductUrl !== newProductUrl) {
        // If the product changed, replace the old product section with the new product section
        productElement.parentNode.insertBefore(html.querySelector('.product'), productElement);
        productElement.remove();

        // Focus the input for the last clicked option value
        this.querySelector(`#${optionValueElement.id}`).focus();

        // Update the URL
        updateUrl(newProductUrl, newProductTitle);
        renderPDPSections(newProductUrl);

        const event = new Event('section:load');
        document.dispatchEvent(event);

        // Update anything else that depends on product, such as URL and recommended products
        return;
      }

      this.querySelector('.optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;
      this.querySelector(`#${optionValueElement.id}`).focus();

      const priceEl = this.querySelector('.price');
      if (newVariantId) {
        priceEl.innerHTML = html.querySelector('.price').innerHTML;
        // Update any additional states here
      } else {
        priceEl.innerHTML = '';
        // Set additional unavailable states here
      }

      setTimeout(function () {
        document.querySelector('.breadcrumbs__list').style.display = 'block';
      }, 2000);

      stickyAtcButton?.classList.remove('visible');

      // Update the URL
      updateUrl(newProductUrl, newProductTitle);
      const event = new Event('section:load');
      document.dispatchEvent(event);
    });
}

function updateUrl(newUrl, newTitle) {
  if (newUrl) {
    history.pushState(null, newTitle || '', newUrl);
    if (newTitle) {
      document.title = newTitle;
    }
  }
}

function getCollectionTitle(value, interstitialBreadcrumb) {
  var appToken = window.compareAppToken;

  if (!value) {
    interstitialBreadcrumb && interstitialBreadcrumb.classList.add('none');
    return Promise.resolve();
  }

  return fetch(`${window.Shopify.routes.root}api/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'Access-Control-Origin': '*',
      'X-Shopify-Storefront-Access-Token': appToken,
    },
    body: `query {
                collectionByHandle(handle: "${value}") { 
                  title
                  handle
                }
              }`,
  }).then((response) => response.json());
}

function renderPDPSections(newProductUrl) {
  const sectionIds = [
    'section-product-breadcrumbs',
    'section-band-upsells',
    'section-product-features',
    'section-product-specifications',
    'section-product-full-width',
    'section-product-full-width_video',
    'section-product-fifty_fifty',
    'section-product-fifty_fifty-2',
  ];

  sectionIds.forEach((sectionId) => {
    fetch(`${newProductUrl}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(html, 'text/html');
        const sectionContent = parsedDocument.querySelector(`[data-section-id="${sectionId}"]`);

        if (sectionContent) {
          document.getElementById(sectionId).innerHTML = sectionContent.innerHTML;
        }
      })
      .catch((error) => {
        console.error(`Failed to load section ${sectionId}: `, error);
      });
  });
}

document.getElementById('productSection').addEventListener('change', function (event) {
  setTimeout(function () {
    let interstitialBreadcrumb = document.querySelector('[data-interstitial-breadcrumb]');
    let productCollectionHandle =
      document.referrer.includes('collections') && document.referrer.split('/').pop().split('?').shift();

    if (!interstitialBreadcrumb || !productCollectionHandle) {
      return;
    }

    getCollectionTitle(productCollectionHandle, interstitialBreadcrumb).then((response) => {
      if (response && response.data && response.data.collectionByHandle) {
        interstitialBreadcrumb.innerHTML = `<a href="${window.Shopify.routes.root}collections/${response.data.collectionByHandle.handle}" class="breadcrumbs__link" title="${response.data.collectionByHandle.title}">${response.data.collectionByHandle.title}</a>`;
      } else {
        interstitialBreadcrumb.style.display = 'none';
      }
    });
    setTimeout(function () {
      document.querySelector('.breadcrumbs__list').style.display = 'block';
    }, 2000);
  }, 1500);
});
document.getElementById('productSection').addEventListener('change', onVariantChange);
